import angular from "angular";

export type JoinFilter<T, Prop extends keyof T> = {
    (array: T, separator: string, prop: Prop): string;
};

export const joinFilterFactory =
    <T, Prop extends keyof T>() =>
    (array: T, separator: string, prop: Prop) => {
        if (!Array.isArray(array)) {
            return array; // if not array return original - can also throw error
        }

        return (
            !!prop
                ? array.map(function (item) {
                      return item[prop];
                  })
                : array
        ).join(separator);
    };

joinFilterFactory.componentName = "join";

angular.module("topline.filters").filter(joinFilterFactory.componentName, joinFilterFactory);
